import { render, staticRenderFns } from "./AdditionalFields.vue?vue&type=template&id=2c00473e&scoped=true"
import script from "./AdditionalFields.vue?vue&type=script&lang=ts"
export * from "./AdditionalFields.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalFields.vue?vue&type=style&index=0&id=2c00473e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00473e",
  null
  
)

export default component.exports